import { render, staticRenderFns } from "./BigTitle.vue?vue&type=template&id=a8ac2666&"
import script from "./BigTitle.vue?vue&type=script&lang=js&"
export * from "./BigTitle.vue?vue&type=script&lang=js&"
import style0 from "./BigTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports